import { Config } from "../../../../../../api/config";
export var BranchToBranchOutwardKeys = {
    BToBOutwardType: 'BToBOutward',
    BToBRequisitionType: 'BToBRequisition',
    Paging: "BToBOutwardPaging",
    BToBOutwardDetails: "BToBOutwardDetails",
    Create: 'Create',
    BToBRequisitioList: 'BToBRequisitioList',
    BToBBranchList: 'branchListGet',
    PriorityList: 'PriorityList',
    TransporterNameList: 'TransporterNameList',
    ShippingMethodList: 'ShippingMethodList',
    TransporterNameOrganizationTypeGroud: 10,
    StockTransferRequisition: 'StockTransferRequisition',
    DownloadAttachmentList: 'DownloadAttachmentList',
    UploadAttachment: 'UploadAttachment',
    ProductList: "ProductList",
    SerialNumberList: 'SerialNumberList',
    UOMDetailsByProductId: 'UOMDetailsByProductId',
    LocationDetails: 'LocationDetails',
    ProductPrices: 'ProductPrices',
    RequisitionDetailsById: "RequisitionDetails"
};
export var viewTypeOptions = ["My transfer", "All transfer"];
export var BranchOutwardApiKeys = [BranchToBranchOutwardKeys.Paging];
export var BToBOutwardStatusEnum = /*#__PURE__*/ function (BToBOutwardStatusEnum) {
    BToBOutwardStatusEnum["Completed"] = "Completed";
    return BToBOutwardStatusEnum;
}({});
export var BToBOutwardPagingUrl = "".concat(Config.baseURL, "StockTransferRequisition/Paging");
export var BToBRequisitionIdUrl = "".concat(Config.baseURL, "StockTransferRequisition/CompletedStockTransferRequisition");
export var BranchListUrl = "".concat(Config.baseURL, "Organization/ListOrganization");
export var PriorityListUrl = "".concat(Config.baseURL, "Priority/List");
export var TransporterListUrl = "".concat(Config.baseURL, "Organization/List");
export var ShippingMethodListUrl = "".concat(Config.baseURL, "ShippingMethod/List");
export var BToBOutwardAttachmentCreateUrl = "".concat(Config.baseURL, "InventoryAttachment/Create");
export var BToBOutwardAttachmentDeleteUrl = "".concat(Config.baseURL, "InventoryAttachment/DeleteInventoryAttachment");
export var ProductListUrl = "".concat(Config.baseURL, "Product/List");
export var BToBOutwardCreateUrl = "".concat(Config.baseURL, "StockTransferRequisition/CreateInwardOutwardBToBProcess");
export var B2BOutwardSerialNoListUrl = "".concat(Config.baseURL, "Asset/ListBySerilalNo");
export var CheckDefaultTrackingTypeUrl = "".concat(Config.baseURL, "ProductInventoryDefaultConfiguration/CheckDefaultTrackingType");
export var GetProductPriceUrl = "".concat(Config.baseURL, "ProductSalePrice/GetPriceDetail");
export var GetAvailableQuantityUrl = "".concat(Config.baseURL, "Inventory/GetAvailableQuantity");
export var getAvailableQtyByWarehouseUrl = "".concat(Config.baseURL, "Inventory/GetAvailableQtyByWarehouse");
export var LocationByWarehouseListUrl = "".concat(Config.baseURL, "Location/ByWarehouseId");
export var BToBWarehouseListUrl = "".concat(Config.baseURL, "Warehouse/ByTenant");
export var getRequisitionDetailsByIdUrl = function (id) { return "".concat(Config.baseURL, "StockTransferRequisition/").concat(id, "/StockTransferRequisitionWithDetails"); };
